import { useEffect, useState } from "react";
import {
  ANALYTICS_CONSENT_EVENT,
  AnalyticsConsent,
  getAnalyticsConsent,
} from "@/lib/analyticsConsent";

export const useAnalyticsConsent = () => {
  const [consent, setConsent] = useState<AnalyticsConsent>(() =>
    typeof window === "undefined" ? null : getAnalyticsConsent(),
  );

  useEffect(() => {
    const handler = () => setConsent(getAnalyticsConsent());
    window.addEventListener(ANALYTICS_CONSENT_EVENT, handler);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, handler);
  }, []);

  return consent;
};
